import React from "react";
type SVGConfigPrintToolProps = { className?: string };
const SVGConfigPrintTool: React.FC<SVGConfigPrintToolProps> = (props) => (
	<svg
		width="83"
		height="73"
		viewBox="0 0 83 73"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1653_21171)">
			<path
				d="M58.522 45.1886V46.6882H57.2981C56.0048 46.6882 54.7645 47.1999 53.8501 48.1108C52.9356 49.0217 52.4219 50.2572 52.4219 51.5454V60.0454C52.4219 61.0115 52.8072 61.9381 53.493 62.6212C54.1789 63.3044 55.1091 63.6882 56.079 63.6882H58.5171V64.9025C58.5171 65.8686 58.9024 66.7952 59.5883 67.4784C60.2741 68.1616 61.2043 68.5454 62.1743 68.5454H71.9266C72.8966 68.5454 73.8268 68.1616 74.5126 67.4784C75.1985 66.7952 75.5838 65.8686 75.5838 64.9025V63.6882H78.0219C78.9918 63.6882 79.922 63.3044 80.6079 62.6212C81.2937 61.9381 81.679 61.0115 81.679 60.0454V51.5454C81.679 50.2572 81.1653 49.0217 80.2508 48.1108C79.3363 47.1999 78.0961 46.6882 76.8028 46.6882H75.5838V45.1728C75.5838 44.7339 75.4969 44.2992 75.3281 43.8938C75.1594 43.4883 74.912 43.12 74.6002 42.8098C74.2884 42.4997 73.9182 42.2538 73.5109 42.0863C73.1036 41.9188 72.6672 41.8329 72.2265 41.8335L61.8695 41.8493C60.9812 41.8506 60.1298 42.203 59.5022 42.8291C58.8745 43.4552 58.522 44.3038 58.522 45.1886ZM75.5838 61.8668V58.8311C75.5838 57.8649 75.1985 56.9383 74.5126 56.2552C73.8268 55.572 72.8966 55.1882 71.9266 55.1882H62.1743C61.2043 55.1882 60.2741 55.572 59.5883 56.2552C58.9024 56.9383 58.5171 57.8649 58.5171 58.8311V61.8668H56.079C55.5941 61.8668 55.1289 61.6749 54.786 61.3333C54.4431 60.9917 54.2504 60.5284 54.2504 60.0454V51.5454C54.2504 50.7402 54.5715 49.9681 55.1431 49.3988C55.7146 48.8295 56.4898 48.5096 57.2981 48.5096H76.8028C77.6111 48.5096 78.3863 48.8295 78.9578 49.3988C79.5294 49.9681 79.8504 50.7402 79.8504 51.5454V60.0454C79.8504 60.5284 79.6578 60.9917 79.3149 61.3333C78.9719 61.6749 78.5068 61.8668 78.0219 61.8668H75.5838ZM73.7552 45.1728V46.6882H60.3506V45.1886C60.3506 44.3507 61.0308 43.6719 61.8719 43.6707L72.229 43.6549C72.4293 43.6546 72.6277 43.6936 72.8128 43.7698C72.998 43.8459 73.1663 43.9577 73.308 44.0986C73.4498 44.2396 73.5623 44.4071 73.639 44.5914C73.7157 44.7757 73.7552 44.9733 73.7552 45.1728ZM62.1743 57.0096H71.9266C72.4116 57.0096 72.8767 57.2015 73.2196 57.5431C73.5626 57.8847 73.7552 58.348 73.7552 58.8311V64.9025C73.7552 65.3856 73.5626 65.8489 73.2196 66.1904C72.8767 66.532 72.4116 66.7239 71.9266 66.7239H62.1743C61.6893 66.7239 61.2242 66.532 60.8813 66.1904C60.5383 65.8489 60.3457 65.3856 60.3457 64.9025V58.8311C60.3457 58.348 60.5383 57.8847 60.8813 57.5431C61.2242 57.2015 61.6893 57.0096 62.1743 57.0096Z"
				fill="#7289AD"
				stroke="#7289AD"
				strokeWidth="1.3"
			/>
		</g>
		<g clipPath="url(#clip1_1653_21171)">
			<path
				d="M29.5574 4.92627L22.1685 12.3152H12.3166V22.167L4.92773 29.5559L12.3166 36.9448V46.7966H22.1685L29.5574 54.1855L36.9462 46.7966H46.7981V36.9448L54.187 29.5559L46.7981 22.167V12.3152H36.9462L29.5574 4.92627Z"
				stroke="#7289AD"
				strokeWidth="4"
				strokeLinejoin="round"
			/>
			<path
				d="M29.5549 36.9443C31.5146 36.9443 33.394 36.1658 34.7796 34.7801C36.1653 33.3944 36.9438 31.515 36.9438 29.5554C36.9438 27.5957 36.1653 25.7163 34.7796 24.3307C33.394 22.945 31.5146 22.1665 29.5549 22.1665C27.5952 22.1665 25.7159 22.945 24.3302 24.3307C22.9445 25.7163 22.166 27.5957 22.166 29.5554C22.166 31.515 22.9445 33.3944 24.3302 34.7801C25.7159 36.1658 27.5952 36.9443 29.5549 36.9443Z"
				stroke="#7289AD"
				strokeWidth="4"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1653_21171">
				<rect
					width="32"
					height="34"
					fill="white"
					transform="translate(51 39)"
				/>
			</clipPath>
			<clipPath id="clip1_1653_21171">
				<rect width="56" height="59" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export default SVGConfigPrintTool;
